<div class="wrapper confinement">
  <div class="back-link-container confinement">
    <a routerLink=".." class="back-on-mobile mat-h2 back-link">
      <mat-icon class="back-link-icon">arrow_back</mat-icon>{{ 'DASHBOARD.MODIFY_DATA' | translate }}
    </a>
  </div>
  <mat-card class="confinement">
    <ng-container *ngIf="formState$ | async as formState">
      <form class="" [ngrxFormState]="formState">
        <mat-card-title class="mat-title">
          {{ 'ACCOUNT.EDIT_ADDRESS.TITLE' | translate }}
        </mat-card-title>
        <mat-card-content class="mat-card-info">
          <p>{{ 'ACCOUNT.EDIT_ADDRESS.INFO' | translate }}</p>
          <!--          <mat-form-field-->
          <!--            *ngIf="userAddress?.address?.company"-->
          <!--            class="form-field form-container"-->
          <!--            appearance="fill"-->
          <!--            gdColumns="auto"-->
          <!--          >-->
          <!--            <mat-label>{{ 'ACCOUNT.ADD_ADDRESS.COMPANY' | translate }}</mat-label>-->
          <!--            <input matInput type="text" [ngrxFormControlState]="formState.controls.company" maxlength="135" />-->
          <!--          </mat-form-field>-->
          <div
            class="user-card-info"
            *ngIf="!(userAddress?.address?.company && userAddress?.customerSubNumber === '0')"
          >
            <mat-form-field class="form-field" appearance="fill" gdArea="name">
              <mat-label>{{ 'ACCOUNT.ADD_ADDRESS.NAME' | translate }}</mat-label>
              <input matInput type="text" [ngrxFormControlState]="formState.controls.firstName" maxlength="20" />
            </mat-form-field>
            <mat-form-field class="form-field" appearance="fill" gdArea="surname">
              <mat-label>{{ 'ACCOUNT.ADD_ADDRESS.SURNAME' | translate }}</mat-label>
              <input matInput type="text" [ngrxFormControlState]="formState.controls.lastName" maxlength="30" />
            </mat-form-field>
          </div>
          <div class="user-card-info">
            <mat-form-field class="form-field" appearance="fill" *ngIf="!userAddress?.address?.company">
              <mat-label>{{ 'ACCOUNT.ADD_ADDRESS.STREET_AND_HOUSE_NUMBER' | translate }}</mat-label>
              <input matInput type="text" [ngrxFormControlState]="formState.controls.street" maxlength="46" />
            </mat-form-field>
            <mat-form-field class="form-field" appearance="fill" *ngIf="!userAddress?.address?.company">
              <mat-label>{{ 'ACCOUNT.ADD_ADDRESS.STREET_2' | translate }}</mat-label>
              <input matInput type="text" [ngrxFormControlState]="formState.controls.street2" maxlength="46" />
            </mat-form-field>
          </div>
          <div class="company-address" *ngIf="!userAddress?.address?.company">
            <mat-form-field class="form-field" appearance="fill" gdArea="postal-code">
              <mat-label>{{ 'ACCOUNT.ADD_ADDRESS.POSTAL_CODE' | translate }}</mat-label>
              <input matInput type="text" [ngrxFormControlState]="formState.controls.postalCode" maxlength="10" />
            </mat-form-field>
            <mat-form-field class="form-field" appearance="fill">
              <mat-label>{{ 'ACCOUNT.ADD_ADDRESS.CITY' | translate }}</mat-label>
              <input matInput type="text" [ngrxFormControlState]="formState.controls.city" maxlength="40" />
            </mat-form-field>
          </div>
          @if (!userAddress?.address?.company) {
          <div>
            <cover-select-country
              appearance="fill"
              [itemsLoadSize]="5"
              [objectValue]="{
                alpha2Code: (addressToEditState$ | async)!!.countryCode,
                name: '',
                alpha3Code: '',
                numericCode: '',
                callingCode: ''
              }"
              label="{{ 'ACCOUNT.ADD_ADDRESS.COUNTRY' | translate }}"
              (countrySelected)="changeSelectedCountry($event)"
            />
            <!--            <mat-select-country-->
            <!--              appearance="fill"-->
            <!--              [itemsLoadSize]="5"-->
            <!--              [value]="{-->
            <!--                alpha2Code: (addressToEditState$ | async)!!.countryCode,-->
            <!--                name: '',-->
            <!--                alpha3Code: '',-->
            <!--                numericCode: '',-->
            <!--                callingCode: ''-->
            <!--              }"-->
            <!--              label="{{ 'ACCOUNT.ADD_ADDRESS.COUNTRY' | translate }}"-->
            <!--              (onCountrySelected)="changeSelectedCountry($event)"-->
            <!--            ></mat-select-country>-->
          </div>
          }
        </mat-card-content>
        <mat-card-actions>
          <!--      <mat-button-toggle-->
          <!--        #button-->
          <!--        class="mat-flat-button dark-plain-button"-->
          <!--        ngClass.sm="left-button"-->
          <!--        ngClass.xs="bottom-distance"-->
          <!--      >-->
          <!--        <mat-icon color="primary" class="star-icon">{{ button.checked ? 'star' : 'star_border' }}</mat-icon>-->
          <!--        <span>{{ 'GENERAL.SET_AS_DEFAULT' | translate }}</span></mat-button-toggle-->
          <!--      >-->
          <button
            mat-flat-button
            color="primary"
            [class.button-spinner]="this.pending"
            [disabled]="this.pending || !this.formIsDirty"
            (click)="onSubmit(formState)"
          >
            {{ 'GENERAL.SAVE_CHANGES' | translate }}
          </button>
        </mat-card-actions>
      </form>
    </ng-container>
  </mat-card>
</div>
